import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import Dashboard from "./Components/Dashboard";
import HomePage from "./Components/Header";
import Sidebar from "./Components/Sidebar";
import SitesPerCounty from "./Pages/Reports/SitesPerCounty";
import ProductsPerCountyReport from "./Pages/Reports/ProductsPerCountyReport";

import Constituencies from "./Pages/Configurations/Constituencies";
import Counties from "./Pages/Configurations/Counties";
import Countries from "./Pages/Configurations/Countries";

import DocType from "./Pages/Configurations/DocType";
import Stafftypes from "./Pages/Configurations/Stafftypes";
import SubCounties from "./Pages/Configurations/SubCounties";
import Towns from "./Pages/Configurations/Towns";
import Wards from "./Pages/Configurations/Wards";

import Approvalsetup from "./Pages/Configurations/Approvalsetup";
import AuditTrails from "./Pages/Configurations/AuditTrails";
import EditProfile from "./Pages/Configurations/EditProfile";
import EmailTemplates from "./Pages/Configurations/EmailTemplates";
import Login from "./Pages/Configurations/Login";
import Logout from "./Pages/Configurations/Logout";
import ProjectStatus from "./Pages/Configurations/ProjectStatus";
import Register from "./Pages/Configurations/Register";
import Roles from "./Pages/Configurations/Roles";
import SecurityGroups from "./Pages/Configurations/SecurityGroups";
import Smtp from "./Pages/Configurations/Smtp";
import Users from "./Pages/Configurations/Users";

import Governances from "./Pages/Instituionsmanagements/Governances";

import Projects from "./Pages/Instituionsmanagements/Projects";

//Expatriates
import Applications from "./Pages/Expatriates/Applications";

//reports
import ProductsReport from "./Pages/Reports/ProductsReport";
import MouReport from "./Pages/Reports/MouReport";
import MeReport from "./Pages/Reports/MeReport";
import InvestmentsReport from "./Pages/Reports/InvestmentsReport";
import SafetyReport from "./Pages/Reports/SafetyReport";

import Banks from "./Pages/Configurations/Bank";
import BankAccounts from "./Pages/Configurations/BankAccounts";
import BankAccountsApproval from "./Pages/Configurations/BankAccountsApproval";
import BankBranch from "./Pages/Configurations/BankBranch";
import CapitationCriteria from "./Pages/Configurations/CapitationCriteria";
import Contacts from "./Pages/Configurations/Contacts";
import UserApproval from "./Pages/Configurations/UserApproval";
import UDCategory from "./Pages/Configurations/UserCategories";
import UserCodes from "./Pages/Configurations/UserCodes";

// Products
import AddProducts from "./Pages/Products/AddProducts";
import ProductCategory from "./Pages/Products/Category";
import ProductHours from "./Pages/Products/ProductHours";
import ProductStatus from "./Pages/Products/Status";

//  Investment
import AddInvestment from "./Pages/Investment/AddInvestment";

// Marketing
import Marketing from "./Pages/Marketing/Marketing";

// MOUs
import AddMous from "./Pages/MOU/AddMous";
import MouStatus from "./Pages/Configurations/MouStatus";

// ME
import Indicators from "./Pages/ME/Indicators";

// PolicyResearch
import AddPolicy from "./Pages/PolicyResearch/AddPolicy";

// Tour Package
import Destination from "./Pages/Tour Package/Destination";
import Guides from "./Pages/Tour Package/Guides";
import TourPackage from "./Pages/Tour Package/TourPackage";

// Tourism Safety
import IncidentLikelyHood from "./Pages/Tourismsafety/IncidentLikelyHood";
import IncidentTypes from "./Pages/Tourismsafety/IncidentTypes";
import SecurityIncident from "./Pages/Tourismsafety/SecurityIncident";
import SeverityLevel from "./Pages/Tourismsafety/SeverityLevel";

import ApproverModule from "./Pages/Configurations/ApproverModule";

import "../node_modules/@syncfusion/ej2-base/styles/material.css";
import "../node_modules/@syncfusion/ej2-buttons/styles/material.css";
import "../node_modules/@syncfusion/ej2-calendars/styles/material.css";
import "../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
import "../node_modules/@syncfusion/ej2-inputs/styles/material.css";
import "../node_modules/@syncfusion/ej2-navigations/styles/material.css";
import "../node_modules/@syncfusion/ej2-popups/styles/material.css";
import "../node_modules/@syncfusion/ej2-react-grids/styles/material.css";
import "../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";

function App() {
  let xtoken = window.sessionStorage.getItem("xtoken");
  let securitygroup = window.sessionStorage.getItem("securitygroup");
  if (xtoken) {
    return (
      <div
        id="page-container"
        class="fade page-sidebar-fixed page-header-fixed"
      >
        <HomePage />
        <HashRouter>
          <Sidebar />
          <Switch>
            <Route path="/" exact component={Dashboard} />;{" "}
            <Route path="/Smtp" exact component={Smtp} />;{" "}
            <Route path="/Counties" exact component={Counties} />;{" "}
            <Route path="/Countries" exact component={Countries} />;{" "}
            <Route path="/SecurityGroups" exact component={SecurityGroups} />;{" "}
            <Route path="/Users" exact component={Users} />;{" "}
            <Route path="/Roles" exact component={Roles} />;{" "}
            <Route path="/Logout" exact component={Logout} />;{" "}
            <Route path="/EditProfile" exact component={EditProfile} />;{" "}
            <Route path="/SitesPerCounty" exact component={SitesPerCounty} />;
            <Route
              path="/ProductsPerCountyReport"
              exact
              component={ProductsPerCountyReport}
            />
            ;
            <Route
              path="/CapitationCriteria"
              exact
              component={CapitationCriteria}
            />
            ; <Route path="/Governances" exact component={Governances} />;{" "}
            <Route path="/Projects" exact component={Projects} />;{" "}
            <Route path="/ProjectStatus" exact component={ProjectStatus} />;{" "}
            <Route path="/DashBoard" exact component={Dashboard} />;{" "}
            <Route path="/AuditTrails" exact component={AuditTrails} />;{" "}
            <Route path="/banks" exact component={Banks} />
            <Route path="/docType" exact component={DocType} />
            <Route path="/contacts" exact component={Contacts} />{" "}
            <Route path="/usercodes" exact component={UserCodes} />{" "}
            <Route path="/udcategory" exact component={UDCategory} />{" "}
            <Route path="/approvers" exact component={Approvalsetup} />{" "}
            <Route path="/approvermodules" exact component={ApproverModule} />
            <Route path="/BankAccounts" exact component={BankAccounts} />
            <Route
              path="/BankAccountsApproval"
              exact
              component={BankAccountsApproval}
            />
            <Route path="/Bankbranch" exact component={BankBranch} />
            <Route
              path="/SecurityIncident"
              exact
              component={SecurityIncident}
            />{" "}
            <Route path="/Towns" exact component={Towns} />;{" "}
            <Route path="/Constituencies" exact component={Constituencies} />;{" "}
            <Route path="/Wards" exact component={Wards} />;{" "}
            <Route path="/SubCounties" exact component={SubCounties} />;{" "}
            <Route path="/Stafftypes" exact component={Stafftypes} />;
            <Route
              path="/IncidentLikelyHood"
              exact
              component={IncidentLikelyHood}
            />
            ;
            <Route path="/IncidentTypes" exact component={IncidentTypes} />;
            <Route path="/SeverityLevel" exact component={SeverityLevel} />;
            {/* Expatriates */}
            <Route path="/Applications" exact component={Applications} />;
            <Route path="/AddProducts" exact component={AddProducts} />;
            <Route path="/ProductCategory" exact component={ProductCategory} />;
            <Route path="/ProductStatus" exact component={ProductStatus} />;
            <Route path="/ProductHours" exact component={ProductHours} />;
            <Route path="/AddMous" exact component={AddMous} />;
            <Route path="/MOUStatus" exact component={MouStatus} />;
            <Route path="/AddInvestments" exact component={AddInvestment} />;
            <Route path="/Marketing" exact component={Marketing} />;
            <Route path="/TourPackage" exact component={TourPackage} />;
            <Route path="/Destination" exact component={Destination} />;
            <Route path="/LocalGuides" exact component={Guides} />;
            <Route path="/Policy" exact component={AddPolicy} />;
            <Route path="/EmailTemplates" exact component={EmailTemplates} />
            <Route path="/Approvalsetup" exact component={Approvalsetup} />
            <Route path="/products_report" exact component={ProductsReport} />
            <Route path="/mou_report" exact component={MouReport} />
            <Route path="/me_report" exact component={MeReport} />
            <Route
              path="/investments_report"
              exact
              component={InvestmentsReport}
            />
            <Route path="/safety_report" exact component={SafetyReport} />
            <Route path="/Indicators" exact component={Indicators} />
            {/* Default redirect for unknown paths */}
            <Redirect to="/Login" />
          </Switch>
        </HashRouter>
      </div>
    );
  } else {
    return (
      <div>
        <HashRouter>
          <Switch>
            <Route path="/" exact component={Login} />;
            <Route path="/Register" exact component={Register} />;
            <Route path="/Login" exact component={Login} />;
            <Route path="/Logout" exact component={Logout} />;
            {/* Default redirect for unknown paths */}
            <Redirect to="/Login" />
          </Switch>
        </HashRouter>
      </div>
    );
  }
}

export default App;
